import {
    content as ecologicaContent,
    faqSchema as ecologicaFaq,
} from "./content/curatenie-ecologica";
import {
    content as parcariContent,
    faqSchema as parcariFaq,
} from "./content/curatenie-parcari-subterane";
import {
    content as deseuriContent,
    faqSchema as deseuriFaq,
} from "./content/deseuri-constructii-demolari";
import {
    content as dezinfectieContent,
    faqSchema as dezinfectieFaq,
} from "./content/dezinfectie-vs-curatenie";
import {
    content as intretinereContent,
    faqSchema as intretinereFaq,
} from "./content/ce-inseamna-curatenie-de-intretinere";
import {
    content as firmaContent,
    faqSchema as firmaFaq,
} from "./content/ce-inseamna-o-firma-de-curatenie-profesionala";
import {
    content as tehnicaContent,
    faqSchema as tehnicaFaq,
} from "./content/ce-inseamna-curatenia-tehnica";
import {
    content as bucatarieContent,
    faqSchema as bucatarieFaq
} from "./content/cum-facem-curatenie-in-bucatarie";
import {
    content as fitnessContent,
    faqSchema as fitnessFaq
} from "./content/curatenie-sali-fitness";
import {
    content as showroomContent,
    faqSchema as showroomFaq
} from "./content/curatenie-showroom-auto";
import {
    content as scoliGradiniteContent,
    faqSchema as scoliGradiniteFaq
} from "./content/curatenie-scoli-gradinite";
import {
    content as clinicaMedicalaContent,
    faqSchema as clinicaMedicalaFaq
} from "./content/curatenie-clinica-medicala";
import {
    content as catDureazaContent,
    faqSchema as catDureazaFaq
} from "./content/cat-dureaza-o-curatenie-profesionala";
import {
    content as externalizareContent,
    faqSchema as externalizareFaq
} from "./content/externalizare-servicii-curatenie";
import {
    content as mutareContent,
    faqSchema as mutareFaq
} from "./content/curatenie-apartament-mutare-predare";
import {
    content as generalaVsIntretinereContent,
    faqSchema as generalaVsIntretinereFaq
} from "./content/curatenie-generala-vs-intretinere-diferente";
import {
    content as hoteluriPensiuniContent,
    faqSchema as hoteluriPensiuniFaq
} from "./content/curatenie-hoteluri-pensiuni-bucuresti";
import {
    content as catCostaFirmaContent,
    faqSchema as catCostaFirmaFaq
} from "./content/cat-costa-firma-curatenie-bucuresti-preturi";
import {
    content as spalareMecanizataContent,
    faqSchema as spalareMecanizataFaq
} from "./content/spalare-mecanizata-pardoseli-industriale";
import {
    content as pretCuratenieBirouriContent,
    faqSchema as pretCuratenieBirouriFaq
} from "./content/pret-curatenie-birouri";

import intretinereCover from "assets/images/poze-site/ce_inseamna_curatenie_de_intretinere.png";
import firmaCover from "assets/images/poze-site/ce_inseamna_o_firma_de_curatenie_profesionala.png";
import tehnicaCover from "assets/images/poze-site/coperta-curatenie-tehnica.webp";
import bucatarieCover from "assets/images/poze-site/curatenie-bucatarie.webp";


const blogPosts = [
    {
        id: "spalare-mecanizata-pardoseli-industriale",
        title: "Spălarea mecanizată a pardoselilor industriale: metoda corectă pentru hale, depozite și fabrici",
        metaTitle: "Spălarea mecanizată a pardoselilor industriale (ghid)",
        description:
            "Spălarea mecanizată a pardoselilor industriale: ce metodă alegi pentru beton sau epoxid, cât de des o faci și cum reduci întreruperile. Vezi ghidul.",
        image: "https://i.ibb.co/zV5TmNwg/image-2026-10-22-T175948-018.jpg",
        imageAlt: "spălarea mecanizată a pardoselilor industriale",
        date: "2026-10-31",
        category: "Curățenie Industrială",
        content: spalareMecanizataContent,
        faqSchema: spalareMecanizataFaq,
    },
    {
        id: "pret-curatenie-birouri",
        title: "Cât costă curățenia birourilor? Factorii care influențează prețul și cum compari corect ofertele",
        metaTitle: "Prețul curățeniei pentru birouri: 5 factori care contează",
        description:
            "Prețul curățeniei pentru birouri depinde de suprafață, frecvență și zonele incluse. Vezi ce plătești, de fapt, și cum compari corect ofertele.",
        image: "https://i.ibb.co/bjTCzTSF/image-2026-10-22-T181033-719.jpg",
        imageAlt: "prețul curățeniei pentru birouri",
        date: "2026-10-31",
        category: "Ghid Prețuri",
        content: pretCuratenieBirouriContent,
        faqSchema: pretCuratenieBirouriFaq,
    },
    {
        id: "curatenie-hoteluri-pensiuni-bucuresti",
        title: "Curățenie profesională pentru hoteluri și pensiuni din București: standarde și frecvențe",
        metaTitle: "Curățenie Hoteluri și Pensiuni București | Standarde de Igienă",
        description:
            "Ghid despre curățenia profesională în hoteluri și pensiuni din București: zone de curățat, frecvențe, protocoale de camera și standarde de igienă pentru ospitalitate.",
        image: "https://i.ibb.co/kspTSG36/Whats-App-Image-2026-10-15-at-11-04-10.jpg",
        imageAlt: "curatenie profesionala camera hotel pensiune bucuresti housekeeping",
        date: "2026-10-22",
        category: "Curățenie Ospitalitate",
        content: hoteluriPensiuniContent,
        faqSchema: hoteluriPensiuniFaq,
    },
    {
        id: "cat-costa-firma-curatenie-bucuresti-preturi",
        title: "Cât costă o firmă de curățenie în București? Ghid de prețuri și factori de cost",
        metaTitle: "Cât Costă o Firmă de Curățenie București | Ghid Prețuri",
        description:
            "Află cât costă serviciile unei firme de curățenie în București și ce factori influențează prețul: suprafață, frecvență, tip de curățenie și starea spațiului.",
        image: "https://i.ibb.co/LXMmYgPd/Whats-App-Image-2026-10-15-at-11-36-52.jpg",
        imageAlt: "calculator pret firma curatenie bucuresti factura servicii",
        date: "2026-10-22",
        category: "Ghid Prețuri",
        content: catCostaFirmaContent,
        faqSchema: catCostaFirmaFaq,
    },
    {
        id: "externalizare-servicii-curatenie",
        title: "Externalizarea serviciilor de curățenie: firmă specializată vs personal intern",
        description:
            "Compară externalizarea serviciilor de curățenie cu personalul intern: costuri, continuitate, echipamente, coordonare și controlul calității.",
        image: "https://i.ibb.co/G3Hp1kd5/image-45.jpg",
        date: "2026-09-24",
        category: "Ghiduri B2B",
        content: externalizareContent,
        faqSchema: externalizareFaq,
    },
    {
        id: "curatenie-apartament-mutare-predare",
        title: "Curățenie Apartament la Mutare | Predare-Primire București",
        description:
            "Ce presupune curățenia unui apartament sau a unei vile la mutare: etape, zone critice, checklist de predare-primire și diferența față de curățenia generală.",
        image: "https://i.ibb.co/xS0QH8K6/Whats-App-Image-2026-09-16-at-10-35-56.webp",
        date: "2026-09-24",
        category: "Rezidențial",
        content: mutareContent,
        faqSchema: mutareFaq,
    },
    {
        id: "curatenie-generala-vs-intretinere-diferente",
        title: "Curățenie Generală vs. Întreținere | Care e Diferența",
        description:
            "Care este diferența dintre curățenia generală și curățenia de întreținere, când ai nevoie de fiecare și cum alegi serviciul potrivit pentru casă sau firmă.",
        image: "https://i.ibb.co/N6dM6f7c/Whats-App-Image-2026-09-16-at-10-49-36.webp",
        date: "2026-09-24",
        category: "Sfaturi Curățenie",
        content: generalaVsIntretinereContent,
        faqSchema: generalaVsIntretinereFaq,
    },
    {
        id: "curatenie-clinica-medicala-zone-critice-reguli",
        title: "Cum se face curățenia într-o clinică medicală? Zone critice și reguli de igienă",
        description:
            "Ghid complet privind curățenia într-o clinică medicală: clasificarea zonelor de risc, codul culorilor, etapele de dezinfecție și regulile igienico-sanitare.",
        image: "https://i.ibb.co/hJMjfLSq/curatenie-cabinet-medical-sub100kb.jpg",
        date: "2026-08-27",
        category: "Curățenie Specializată",
        content: clinicaMedicalaContent,
        faqSchema: clinicaMedicalaFaq,
    },
    {
        id: "cat-dureaza-o-curatenie-profesionala-factori",
        title: "Cât durează o curățenie profesională? Factorii care influențează timpul de lucru",
        description:
            "Află cât durează o curățenie profesională pentru apartamente, birouri sau după constructor. Descoperă factorii care influențează durata de lucru.",
        image: "https://i.ibb.co/3mbD6xky/curatenie-sub-100kb.jpg",
        date: "2026-08-27",
        category: "Sfaturi Curățenie",
        content: catDureazaContent,
        faqSchema: catDureazaFaq,
    },
    {
        id: "curatenie-scoli-gradinite",
        title: "Curățenie în școli și grădinițe: reguli și etape | Doral",
        description:
            "Află ce prevăd normele de igienă, care sunt etapele curățeniei în școli și grădinițe și cum pregătești spațiile înainte de noul an școlar.",
        image: "https://i.ibb.co/pBTBx8KT/image-20.jpg",
        date: "2026-08-19",
        category: "Spații Educaționale",
        content: scoliGradiniteContent,
        faqSchema: scoliGradiniteFaq,
    },
    {
        id: "curatenie-showroom-auto",
        title: "Curățenie showroom auto: imagine impecabilă pentru clienți",
        description:
            "Descoperă ce include curățenia într-un showroom auto, de la geamuri și pardoseli până la zonele de expunere și recepție.",
        image: "https://i.ibb.co/JWYPK7C9/Cur-enie-profesional-ntr-un-showroom-auto.jpg",
        date: "2026-08-01",
        category: "Curățenie Spații Comerciale",
        content: showroomContent,
        faqSchema: showroomFaq,
    },
    {
        id: "curatenie-sali-fitness",
        title: "Curățenie săli fitness: aparate, vestiare și zone comune",
        description:
            "Află ce include curățenia profesională pentru săli de fitness, de la igienizarea aparatelor și vestiarelor până la întreținerea zonelor intens circulate.",
        image: "https://i.ibb.co/hJML6vFC/Cur-enie-profesional-pentru-s-li-de-fitness-i-aparate-de-antrenament-2.jpg",
        date: "2026-08-01",
        category: "Curățenie Specializată",
        content: fitnessContent,
        faqSchema: fitnessFaq,
    },
    {
        id: "curatenie-ecologica-green-cleaning-birouri",
        title: "Curățenia ecologică (green cleaning) în birouri și spații comerciale: ce presupune și de ce câștigă teren",
        description:
            "Ce înseamnă curățenia ecologică pentru birouri și spații comerciale, ce produse și metode implică și ce beneficii reale aduce firmei tale.",
        image: "https://i.ibb.co/k2NmWKqG/Eco.jpg",
        date: "2026-07-30",
        category: "Curățenie Birouri",
        content: ecologicaContent,
        faqSchema: ecologicaFaq,
    },
    {
        id: "curatenie-parcari-subterane",
        title: "Curățenia parcărilor subterane: de ce este esențială și cât de des se face",
        description:
            "De ce necesită parcările subterane un tip diferit de curățenie, cât de des se recomandă spălarea mecanizată și ce presupune procesul complet.",
        image: "https://i.ibb.co/LdxxnsV9/Parcari.jpg",
        date: "2026-07-30",
        category: "Curățenie Specializată",
        content: parcariContent,
        faqSchema: parcariFaq,
    },
    {
        id: "cum-facem-curatenie-in-bucatarie",
        title: "Cum facem curatenie in bucatarie — Doral Cleaning",
        description:
            "Descopera cum lucreaza echipa Doral Cleaning in bucataria ta, ce zone primesc atentie speciala si de ce merita o relatie constanta, nu doar ocazionala.",
        image: bucatarieCover,
        date: "2026-06-30",
        category: "Sfaturi Curățenie",
        content: bucatarieContent,
        faqSchema: bucatarieFaq,
    },
    {
        id: "ce-inseamna-curatenia-tehnica",
        title: "Ce înseamnă curățenia tehnică? Ghid complet",
        description:
            "Află ce înseamnă curățenia tehnică, ce activități include, când este necesară și de ce diferă de curățenia obișnuită. Explicat simplu de Doral Cleaning.",
        image: tehnicaCover,
        date: "2026-06-29",
        category: "Curățenie Post Construcție",
        content: tehnicaContent,
        faqSchema: tehnicaFaq,
    },
    {
        id: "ce-inseamna-o-firma-de-curatenie-profesionala",
        title: "Ce înseamnă o firmă de curățenie profesională? Servicii și Soluții",
        description:
            "Descoperă ce servicii oferă o firmă de curățenie: de la vile și apartamente, la spații corporate, hale și depozite. Soluții complete pentru orice spațiu.",
        image: firmaCover,
        date: "2026-06-04",
        category: "Curățenie Birouri",
        content: firmaContent,
        faqSchema: firmaFaq,
    },
    {
        id: "ce-inseamna-curatenie-de-intretinere",
        title: "Ce înseamnă curățenia de întreținere? Ghid complet și beneficii",
        description:
            "Descoperă ce include curățenia de întreținere, diferențele față de curățenia generală și cum un abonament profesional îți menține spațiul impecabil zilnic.",
        image: intretinereCover,
        date: "2026-06-04",
        category: "Curățenie de Întreținere",
        content: intretinereContent,
        faqSchema: intretinereFaq,
    },
    {
        id: "dezinfectie-vs-curatenie",
        title: "Dezinfecție vs. curățenie: care este diferența reală",
        description:
            "Află diferența dintre curățenie și dezinfecție și când este necesară fiecare pentru un spațiu sigur.",
        image: "https://i.ibb.co/7fTygnD/dezinfectie-suprafete.jpg",
        date: "2026-06-04",
        category: "Curățenie de Întreținere",
        content: dezinfectieContent,
        faqSchema: dezinfectieFaq,
    },
    {
        id: "deseuri-constructii-demolari",
        title: "Deșeuri din construcții și demolări: cum le gestionezi corect",
        description:
            "Descoperă regulile și soluțiile pentru colectarea și eliminarea deșeurilor rezultate din construcții.",
        image: "https://i.ibb.co/kg7fd9qd/saci-moloz-deseuri.jpg",
        date: "2026-06-04",
        category: "Curățenie Post Construcție",
        content: deseuriContent,
        faqSchema: deseuriFaq,
    },
];

export default blogPosts;
